const o=o=>o?`${o}/placeholders/coming-soon-600x416.svg`:void 0;export{o as getAppDefaultImageSrc};
